import { useEffect, useState } from 'react'

interface Props {
  startsAt: string | null
  endsAt: string | null
  defeated: boolean
  /** Shown under "Time left" while the battle runs. */
  note?: string
}

function parts(ms: number) {
  const s = Math.max(0, Math.floor(ms / 1000))
  const d = Math.floor(s / 86400)
  const h = Math.floor((s % 86400) / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const two = (n: number) => String(n).padStart(2, '0')
  return d > 0 ? `${d}d ${two(h)}h ${two(m)}m` : `${two(h)}h ${two(m)}m ${two(sec)}s`
}

/** "Starts in", "Time left" or "Ended", from the campaign window. Ticks every second. */
export function Countdown({ startsAt, endsAt, defeated, note }: Props) {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [])
  if (defeated || (!startsAt && !endsAt)) return null
  const start = startsAt ? Date.parse(startsAt) : null
  const end = endsAt ? Date.parse(endsAt) : null
  let label: string
  let value: string
  let tone = ''
  let showNote = false
  if (start != null && now < start) {
    label = 'Starts in'
    value = parts(start - now)
  } else if (end != null && now >= end) {
    label = 'Battle'
    value = 'ended'
    tone = ' over'
  } else if (end != null) {
    label = 'Time left'
    value = parts(end - now)
    showNote = !!note
    if (end - now < 6 * 3600 * 1000) tone = ' urgent'
  } else {
    return null
  }
  return (
    <div className={`hud-time${tone}`} aria-live="polite">
      <p className="hud-time-row">
        <span className="hud-time-label">{label}</span>
        <span className="hud-time-value">{value}</span>
      </p>
      {showNote ? <p className="hud-time-note">{note}</p> : null}
    </div>
  )
}
